import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Page listant tous les groupes
export const GroupList = () => {
  const [groups, setGroups] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetch('http://localhost:3001/groups')
      .then(res => res.json())
      .then(setGroups)
      .catch(console.error);
  }, []);

  return (
    <div className="container py-5">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>👥 Groupes</h2>
        <button className="btn btn-primary" onClick={() => navigate('/groups/create')}>
          ➕ Créer un groupe
        </button>
      </div>
      <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
        {groups.map(group => (
          <div className="col" key={group.id}>
            <div className="card shadow-sm rounded-4">
              <div className="card-body">
                <h5 className="card-title">{group.name}</h5>
                <p className="card-text text-muted">{group.description}</p>
                <button className="btn btn-outline-primary btn-sm" onClick={() => navigate(`/groups/${group.id}`)}>
                  Voir le groupe
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// Page de détails d'un groupe
export const GroupDetail = ({ groupId }) => {
  const [group, setGroup] = useState(null);

  useEffect(() => {
    fetch(`http://localhost:3001/groups/${groupId}`)
      .then(res => res.json())
      .then(setGroup)
      .catch(console.error);
  }, [groupId]);

  if (!group) return <div className="text-center py-5">Chargement du groupe...</div>;

  return (
    <div className="container py-5">
      <h2 className="mb-3">{group.name}</h2>
      <p className="text-muted">{group.description}</p>
      <hr />
      <h5 className="mt-4">Vidéos du groupe</h5>
      {/* Liste des vidéos à afficher ici */}
    </div>
  );
};

// Formulaire de création d'un groupe
export const GroupCreate = () => {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    fetch('http://localhost:3001/groups', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, description }),
    })
      .then(res => res.json())
      .then(data => navigate(`/groups/${data.id}`))
      .catch(console.error);
  };

  return (
    <div className="container py-5">
      <h2>Créer un nouveau groupe</h2>
      <form onSubmit={handleSubmit} className="mt-4">
        <div className="mb-3">
          <label className="form-label">Nom du groupe</label>
          <input type="text" className="form-control" value={name} onChange={(e) => setName(e.target.value)} required />
        </div>
        <div className="mb-3">
          <label className="form-label">Description</label>
          <textarea className="form-control" rows="3" value={description} onChange={(e) => setDescription(e.target.value)} required />
        </div>
        <button type="submit" className="btn btn-success">Créer</button>
      </form>
    </div>
  );
};